import React, { useEffect, useRef } from "react";
import { Container, Grid, GridItem } from "../../../utils/CustomComponents";

// Grid Icons
import { ReactComponent as Trust } from "../../../img/Section/Trust.svg";
import { ReactComponent as Arrows } from "../../../img/Section/Arrows.svg";
import { ReactComponent as Dashboard } from "../../../img/Section/Dashboard.svg";
import { ReactComponent as Investment } from "../../../img/Section/Investment.svg";

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
function WhyChooseUs() {
    gsap.registerPlugin(ScrollTrigger);
    const grid = useRef();
    useEffect(() => {
        const items_grid = gsap.utils.toArray(grid.current.children);
        items_grid.forEach((item_grid) => {
            gsap.from(item_grid, {
                scrollTrigger: item_grid,
                y: 100,
                opacity: 0,
                duration: 1,
                scale: 0.5,
                transformOrigin: "center center",
                ease: "power4.Out",
                stagger: { each: 0.5 },
            });
        });
    }, []);
    return (
        <div id="whyChooseUs" className="grid_style">
            <Container>
                <h1 className="header">Features of Dgreat Allot Pensions</h1>
                <Grid gridRef={grid}>
                    <GridItem header="Security" icon={<Trust />}>
                        With our pension system built on Blockchain technology, your pension funds
                        are totally secured and assured.
                    </GridItem>
                    <GridItem header="Decentralization" icon={<Arrows />}>
                        Dgreat Allot Pension System empowers pensioners to have power over their
                        accrued pension funds with the power of Decentralization technology.
                    </GridItem>
                    <GridItem header="Pension For Everyone" icon={<Dashboard />}>
                        With our individual pension system, you become pensionable as a
                        self-employed individual or entrepreneur, making everyone have pensions
                        without necessarily being employed.
                    </GridItem>
                    <GridItem header="Crypto Staking" icon={<Investment />}>
                        Don’t just lock up your pension funds, you can also choose to stake your
                        pensions in a crypto token and earn more with your money before your
                        retirement age.
                    </GridItem>
                </Grid>
            </Container>
        </div>
    );
}

export default WhyChooseUs;
